module.exports = __webpack_public_path__ + "img/GNWT_bear.a913dcf0.svg";